import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@app-core/services';
import { RouterService } from '@app-core/services/router.service';

export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const routerService = inject(RouterService);

  return authService
    .isAuthenticated()
    .then((isAuthenticated) => {
      if (isAuthenticated) {
        routerService.navigateToContent();

        return false;
      } else {
        return true;
      }
    })
    .catch(() => true);
};
